export const DeckIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M2 5.5A3.5 3.5 0 0 1 5.5 2h9.333a3.5 3.5 0 0 1 3.5 3.5v9.333a3.5 3.5 0 0 1-3.5 3.5H5.5a3.5 3.5 0 0 1-3.5-3.5V5.5Z" />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.833 18.333H5.5l-.18-.004a3.5 3.5 0 0 1-3.315-3.315L2 14.833V5.5a3.5 3.5 0 0 1 3.32-3.495L5.5 2h9.333l.18.005a3.5 3.5 0 0 1 3.32 3.495v9.333l-.004.18a3.5 3.5 0 0 1-3.315 3.316l-.181.004Zm0-1.552H5.5a1.948 1.948 0 0 1-1.948-1.948v-3.89h13.23v3.89a1.948 1.948 0 0 1-1.949 1.948Zm0-13.23c1.076 0 1.948.873 1.948 1.949v3.89H3.551V5.5c0-1.076.873-1.948 1.949-1.948h9.333Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
